import { Box } from '@chakra-ui/react';
import { CrawlerRegistrationModal } from './containers/CrawlerRegistrationModal';
import { CrawlerHeader } from './containers/CrawlerHeader';
import { CrawlerList } from './containers/CrawlerList';
import { CrawlerModal } from './containers/CrawlerModal';
import { CrawlerDeleteModal } from './containers/CrawlerDeleteModal';
import { CrawlerAddDetailModal } from './containers/CrawlerAddDetailModal';

export const CrawlerPageView = () => (
  <>
    <Box m="40px">
      <CrawlerHeader />
      <CrawlerList />
    </Box>
    <CrawlerRegistrationModal />
    <CrawlerModal />
    <CrawlerDeleteModal />
    <CrawlerAddDetailModal />
  </>
);
